export interface ExportResponsePayload {
    ExecuteTimeMs?: number;
    Count?: number;
    Error?: string;
    Details?: string;
    error?: string;
    details?: string;
    detail?: string;
    title?: string;
    errors?: Record<string, string[] | string>;
}

export type ParsedExportResponse = ExportResponsePayload | string | undefined;

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export const parseExportResponseBody = (
    responseText: string,
    contentType: string | null
): ParsedExportResponse => {
    const trimmedResponse = responseText.trim();
    if (!trimmedResponse) {
        return undefined;
    }

    try {
        const parsedResponse: unknown = JSON.parse(trimmedResponse);
        if (typeof parsedResponse === 'string') {
            return parsedResponse.trim() || undefined;
        }
        if (isRecord(parsedResponse)) {
            return parsedResponse as ExportResponsePayload;
        }
    } catch {
        if (contentType?.toLowerCase().startsWith('text/plain')) {
            return trimmedResponse;
        }
    }

    return undefined;
};

export const getExportErrorResponse = (
    responseBody: ParsedExportResponse,
    status: number,
    statusText: string
) => {
    if (typeof responseBody === 'string') {
        return {
            ExecuteTimeMs: 0,
            Count: 0,
            Error: responseBody,
        };
    }

    const validationError = responseBody?.errors
        ? Object.entries(responseBody.errors)
            .flatMap(([field, messages]) => {
                const normalizedMessages = Array.isArray(messages) ? messages : [messages];
                return normalizedMessages.map(message => `${field}: ${message}`);
            })
            .join(' ')
        : undefined;

    return {
        ExecuteTimeMs: 0,
        Count: 0,
        Error:
            responseBody?.Error ||
            responseBody?.error ||
            validationError ||
            responseBody?.detail ||
            responseBody?.title ||
            `Server error: ${status} ${statusText}`,
        Details: responseBody?.Details || responseBody?.details || responseBody?.detail,
    };
};
